import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import { LAYOUT } from "assets/theme/avocadoBrand";

/**
 * Dialog full màn hình dưới breakpoint `sm` — form dài + bàn phím điện thoại
 * không che nút Lưu/Huỷ. Dùng: `const fullManHinh = useDialogFullManHinh()` rồi
 * `<Dialog fullScreen={fullManHinh} fullWidth maxWidth="sm" ...>`.
 */
export function useDialogFullManHinh() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
}

/** DialogContent cuộn được khi fullScreen / form dài. */
export const oDialogContent = { pt: 1, overflowY: "auto" };

/**
 * DialogContent cho form dài (Chủ vườn…): chiếm phần giữa, cuộn nội bộ;
 * title/actions nằm ngoài để nút Lưu luôn thấy trên PC.
 */
export const oDialogContentFormDai = {
  pt: 1,
  overflowY: "auto",
  flex: "1 1 auto",
};

/** DialogActions cho phép nút xuống dòng trên màn hẹp. */
export const oDialogActions = { px: 2, pb: 2, gap: 1, flexWrap: "wrap" };

/** Actions dính đáy form dài (không bị kéo theo nội dung). */
export const oDialogActionsFormDai = {
  ...oDialogActions,
  flexShrink: 0,
  borderTop: "1px solid",
  borderColor: "divider",
};

/**
 * Paper form dài trên PC: gần full khung (không còn cột hẹp giữa màn hình).
 * Mobile vẫn dùng fullScreen={fullManHinh} — PaperProps này chỉ có hiệu trên sm+.
 * Gắn kèm maxWidth="md" (hoặc "lg") trên Dialog.
 */
export const oDialogPaperFormDai = {
  sx: {
    display: "flex",
    flexDirection: "column",
    width: { sm: "calc(100% - 48px)" },
    maxWidth: { sm: `${LAYOUT.dialogFormMaxWidth}px` },
    height: { sm: "calc(100% - 48px)" },
    maxHeight: { sm: "calc(100% - 48px)" },
    m: { sm: 3 },
  },
};

/** Bọc <form> trong Dialog form dài để layout flex + actions cố định đáy. */
export const oDialogFormFlex = {
  display: "flex",
  flexDirection: "column",
  flex: "1 1 auto",
  minHeight: 0,
  overflow: "hidden",
};
